"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const AuthProvider_1 = require("./AuthProvider");
const Navbar = () => {
    const { user } = (0, AuthProvider_1.useAuth)();
    return (react_1.default.createElement("nav", null,
        react_1.default.createElement("ul", null,
            react_1.default.createElement("li", null,
                react_1.default.createElement(react_router_dom_1.Link, { to: "/" }, "Dashboard")),
            react_1.default.createElement("li", null,
                react_1.default.createElement(react_router_dom_1.Link, { to: "/users" }, "User Licences")),
            user && react_1.default.createElement("li", null,
                react_1.default.createElement(react_router_dom_1.Link, { to: "/logout" }, "Logout")),
            !user && react_1.default.createElement("li", null,
                react_1.default.createElement(react_router_dom_1.Link, { to: "/login" }, "Login")))));
};
exports.default = Navbar;
